import { render, staticRenderFns } from "./EvidenciaMini.vue?vue&type=template&id=478f6a2f&scoped=true"
import script from "./EvidenciaMini.vue?vue&type=script&lang=js"
export * from "./EvidenciaMini.vue?vue&type=script&lang=js"
import style0 from "./EvidenciaMini.vue?vue&type=style&index=0&id=478f6a2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f6a2f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
